var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuilderBottomLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00025 10.7C8.01892 10.7 8.03359 10.6853 8.03359 10.6666C8.03359 10.648 8.01892 10.6333 8.00025 10.6333C7.98159 10.6333 7.96692 10.648 7.96692 10.6666C7.96692 10.6853 7.98159 10.7 8.00025 10.7",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0002 5.36667C8.01887 5.36667 8.03354 5.352 8.03354 5.33333C8.03354 5.31467 8.01887 5.3 8.0002 5.3C7.98154 5.3 7.96687 5.31467 7.96687 5.33333C7.96687 5.352 7.98154 5.36667 8.0002 5.36667",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0002 8.03341C8.01887 8.03341 8.03354 8.01875 8.03354 8.00008C8.03354 7.98141 8.01887 7.96675 8.0002 7.96675C7.98154 7.96675 7.96687 7.98141 7.96687 8.00008C7.96687 8.01875 7.98154 8.03341 8.0002 8.03341",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30024 8.00008C5.30024 8.01875 5.31491 8.03341 5.33358 8.03341C5.35224 8.03341 5.36691 8.01875 5.36691 8.00008C5.36691 7.98141 5.35224 7.96675 5.33358 7.96675C5.31491 7.96675 5.30024 7.98141 5.30024 8.00008",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6335 8.00008C10.6335 8.01875 10.6482 8.03341 10.6668 8.03341C10.6855 8.03341 10.7002 8.01875 10.7002 8.00008C10.7002 7.98141 10.6855 7.96675 10.6668 7.96675C10.6482 7.96675 10.6335 7.98141 10.6335 8.00008",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66683 5.36667C2.6855 5.36667 2.70016 5.352 2.70016 5.33333C2.70016 5.31467 2.6855 5.3 2.66683 5.3C2.64816 5.3 2.6335 5.31467 2.6335 5.33333C2.6335 5.352 2.64816 5.36667 2.66683 5.36667",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6335 13.3333C10.6335 13.352 10.6482 13.3667 10.6668 13.3667C10.6855 13.3667 10.7002 13.352 10.7002 13.3333C10.7002 13.3147 10.6855 13.3 10.6668 13.3C10.6482 13.3 10.6335 13.3147 10.6335 13.3333",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0002 2.70016C8.01887 2.70016 8.03354 2.6855 8.03354 2.66683C8.03354 2.64816 8.01887 2.6335 8.0002 2.6335C7.98154 2.6335 7.96687 2.64816 7.96687 2.66683C7.96687 2.6855 7.98154 2.70016 8.0002 2.70016",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30024 2.66683C5.30024 2.6855 5.31491 2.70016 5.33358 2.70016C5.35224 2.70016 5.36691 2.6855 5.36691 2.66683C5.36691 2.64816 5.35224 2.6335 5.33358 2.6335C5.31491 2.6335 5.30024 2.64816 5.30024 2.66683",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6335 2.66683C10.6335 2.6855 10.6482 2.70016 10.6668 2.70016C10.6855 2.70016 10.7002 2.6855 10.7002 2.66683C10.7002 2.64816 10.6855 2.6335 10.6668 2.6335C10.6482 2.6335 10.6335 2.64816 10.6335 2.66683",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66683 2.70016C2.6855 2.70016 2.70016 2.6855 2.70016 2.66683C2.70016 2.64816 2.6855 2.6335 2.66683 2.6335C2.64816 2.6335 2.6335 2.64816 2.6335 2.66683C2.6335 2.6855 2.64816 2.70016 2.66683 2.70016",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3336 7.96675C13.3149 7.96675 13.3002 7.98141 13.3002 8.00008C13.3002 8.01875 13.3149 8.03341 13.3336 8.03341C13.3522 8.03341 13.3669 8.01875 13.3669 8.00008C13.3669 7.98141 13.3522 7.96675 13.3336 7.96675",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3336 5.3C13.3149 5.3 13.3002 5.31467 13.3002 5.33333C13.3002 5.352 13.3149 5.36667 13.3336 5.36667C13.3522 5.36667 13.3669 5.352 13.3669 5.33333C13.3669 5.31467 13.3522 5.3 13.3336 5.3",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3336 10.6335C13.3149 10.6335 13.3002 10.6482 13.3002 10.6668C13.3002 10.6855 13.3149 10.7002 13.3336 10.7002C13.3522 10.7002 13.3669 10.6855 13.3669 10.6668C13.3669 10.6482 13.3522 10.6335 13.3336 10.6335",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 2.6333C13.3148 2.6333 13.3002 2.64797 13.3002 2.66663C13.3002 2.6853 13.3148 2.69997 13.3335 2.69997C13.3522 2.69997 13.3668 2.6853 13.3668 2.66663C13.3668 2.64797 13.3522 2.6333 13.3335 2.6333",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3336 13.3C13.3149 13.3 13.3002 13.3147 13.3002 13.3333C13.3002 13.352 13.3149 13.3667 13.3336 13.3667C13.3522 13.3667 13.3669 13.352 13.3669 13.3333C13.3669 13.3147 13.3522 13.3 13.3336 13.3",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63987 13.2799V7.67993",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63989 13.4H8.23989",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuilderBottomLeft);
export default ForwardRef;